import Navbar from "../components/Navbar"
import ContactComponent from "../components/ContactComponent"
import Footer from "../components/Footer"
import SEOMetaTags from "../components/SEOMetaTags"

function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <SEOMetaTags 
        title="İletişim - Buğra Teknik Servis"
        description="Karabük'te teknik servis hizmetleri için iletişime geçin. Telefon: 0533 428 70 27. Şirinevler Mahallesi, Karabük."
      />
      <Navbar />
      <div className="pt-16">
        <ContactComponent />
      </div>
      <Footer />
    </div>
  )
}

export default Contact
